/**
 * 파괴 판정 순수 함수 (FR-004). DestructionSystem과 테스트가 공유.
 * 충돌 상대 속도 크기가 오브젝트별 임계값 이상이면 파괴.
 */
export function shouldBreak(relSpeed: number, threshold: number): boolean {
  return relSpeed >= threshold;
}

/**
 * 잡은 물건 스매시 판정(순수). 잡은 물건이 상대와 AABB로 겹치고 스윙 속도가 상대 임계값
 * 이상이면 true. 잡은 물건은 kinematic이라 충돌 이벤트/linvel이 무력 → 매 스텝 기하로 판정한다.
 * 두 bounding box는 전체 치수(full extents [w,h,d]).
 */
export function swingWouldSmash(
  heldPos: { x: number; y: number; z: number },
  heldBB: readonly [number, number, number],
  otherPos: { x: number; y: number; z: number },
  otherBB: readonly [number, number, number],
  swingSpeed: number,
  otherThreshold: number,
): boolean {
  if (!shouldBreak(swingSpeed, otherThreshold)) return false;
  return (
    Math.abs(heldPos.x - otherPos.x) < (heldBB[0] + otherBB[0]) / 2 &&
    Math.abs(heldPos.y - otherPos.y) < (heldBB[1] + otherBB[1]) / 2 &&
    Math.abs(heldPos.z - otherPos.z) < (heldBB[2] + otherBB[2]) / 2
  );
}
